import * as queryString from "query-string";
import { getDollarValue } from "../helpers/currency";
import { FrontendRoutes, getFormLink } from "../routes/routes";
const thresholdPercentage = [105, 115, 130, 150];
const calculateMagicalAmounts = (lastAmountPaid) => {
    const amountsRoundsToFive = thresholdPercentage.map((threshold) => {
        return roundToFiveOrZero((threshold * lastAmountPaid) / 100);
    });
    return amountsRoundsToFive.reduce((calculatedAmounts, current) => {
        const prev = calculatedAmounts[calculatedAmounts.length - 1];
        if (current - prev < 5) {
            return [...calculatedAmounts, prev + 5];
        }
        if (current < 5) {
            return [...calculatedAmounts, 5];
        }
        return [...calculatedAmounts, current];
    }, []);
};
const roundToFiveOrZero = (value) => {
    const restToFive = value % 5;
    if (restToFive > 2.5) {
        return Math.round(value + (5 - restToFive));
    }
    else {
        return Math.round(value - restToFive);
    }
};
export const generateMagicalLink = (frontendUrl, user, magicalLinkPath, amount) => {
    const punctualAmounts = amount && calculateMagicalAmounts(getDollarValue(amount));
    const queryParams = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        address: user?.address,
        city: user?.city,
        postalCode: user?.postalCode,
        state: user?.region,
        country: user?.country,
        amount: amount ? getDollarValue(amount) : undefined,
        punctualAmounts: punctualAmounts
            ? `[${punctualAmounts[0]}, ${punctualAmounts[1]}, ${punctualAmounts[2]}, ${punctualAmounts[3]}]`
            : "[]",
    };
    return `${frontendUrl}/${user.locale.toLowerCase()}${magicalLinkPath}?${queryString.stringify(queryParams)}`;
};
export const getTicketingMagicalLink = (frontendUrl, user, path) => {
    return generateMagicalLink(frontendUrl, user, `${FrontendRoutes.TicketingPage}${path}`);
};
export const getDonationFormMagicalLink = (frontendUrl, user, donationForm, amount) => {
    const magicalLinkPath = getFormLink(donationForm, null);
    return generateMagicalLink(frontendUrl, user, magicalLinkPath, amount);
};
